import { DotLegalMultiSelect } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../localization/useTranslation.ts";
import { useDataSubjectsQuery } from "@common/hooks/useSelectableItemQueries.ts";

export interface SystemDataSubjectsCreationFieldProps {
    selectedIds: Array<string>;
    onChange: (ids: Array<string>) => void;
    errorText?: string;
    disabled: boolean;
}

function SystemDataSubjectsCreationField(props: SystemDataSubjectsCreationFieldProps) {
    const { translateString } = useTranslation();
    const { data, isLoading } = useDataSubjectsQuery();

    return (
        <DotLegalMultiSelect
            isLoading={isLoading}
            options={data}
            chosenOptions={props.selectedIds}
            onChange={props.onChange}
            placeholder={translateString("dataSubjects")}
            label={translateString("dataSubjects")}
            noOptionsLabel={translateString("noOptions")}
            disabled={props.disabled}
            errorText={props.errorText}
        />
    );
}

export default SystemDataSubjectsCreationField;
